<template>
  <div class="page">
    <Header></Header>
    <div class="nodata">
      <img :src="require('@/assets/nodata.png')" class="nodata-icon">
      <div class="nodata-text">您还没有登录，请先登录汽车之家招聘系统</div>
      <van-button class="nodata-btn" @click="onLogin">
        登录
      </van-button>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./Header1";
import Footer from "./Footer";
import Utils from "../utils/Utils";

export default {
  name: "NoLogin",
  components:{
    Header,
    Footer
  },
  data() {
    return {
      app:"",
    };
  },
  mounted: function() {
    this.app = Utils.getApp();
  },
  methods: {
    onLogin()
    {
      if(this.$route.query.returnurl)
      {
        window.location.replace(this.$route.query.returnurl);
      }
      else
      {
        window.location.replace('/');
      }
    }
  }
}
</script>

<style scoped>
.nodata{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 100px;
}
.nodata-icon{
  width: 160px;
  height: 160px;
}
.nodata-text{
  margin-top: 16px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #20253F;
  font-weight: 400;
}
.nodata-btn{
  margin-top: 16px;
  width: 163px;
  height: 44px;
  background-image: linear-gradient(270deg, #206CFE 0%, #4C88FF 100%);
  border-radius: 4px;

  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  text-align: center;
  font-weight: 400;
}
</style>